import DocumentTitle from '../DocumentTitle';
import { Blackjacklogo } from '../ImageLoader';
import {
  Link,
} from "react-router-dom";
const Page_Payments = () => {
    DocumentTitle("CW Creations - Dev Consult Share | Payment");
    return(<div className='Payments'><h1>Select your purpose for payment</h1><Link style={{ textDecoration: 'none','color':'black','display':'inline-block' } } to="/manage-cwgames-account"><div id='btnManageBlackjackSub' className='paymentCategory'><img src={Blackjacklogo}></img><p>Manage Your Premium Subscription</p></div></Link></div>);
}

export default Page_Payments;